/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type UpdateDocumentRawRequest = {
  /**
   * The id of the document.
   */
  documentId: string;
  /**
   * An optional partition to scope the request to. If omitted, accounts created after 1/9/2025 will have the request scoped to the default partition, while older accounts will have the request scoped to all partitions. Older accounts may opt in to strict partition scoping by contacting support@ragie.ai. Older accounts using the partitions feature are strongly recommended to scope the request to a partition.
   */
  partition?: string | null | undefined;
  updateDocumentRawParams: components.UpdateDocumentRawParams;
};

/** @internal */
export const UpdateDocumentRawRequest$inboundSchema: z.ZodType<
  UpdateDocumentRawRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  document_id: z.string(),
  partition: z.nullable(z.string()).optional(),
  UpdateDocumentRawParams: components.UpdateDocumentRawParams$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "document_id": "documentId",
    "UpdateDocumentRawParams": "updateDocumentRawParams",
  });
});
/** @internal */
export type UpdateDocumentRawRequest$Outbound = {
  document_id: string;
  partition?: string | null | undefined;
  UpdateDocumentRawParams: components.UpdateDocumentRawParams$Outbound;
};

/** @internal */
export const UpdateDocumentRawRequest$outboundSchema: z.ZodType<
  UpdateDocumentRawRequest$Outbound,
  z.ZodTypeDef,
  UpdateDocumentRawRequest
> = z.object({
  documentId: z.string(),
  partition: z.nullable(z.string()).optional(),
  updateDocumentRawParams: components.UpdateDocumentRawParams$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    documentId: "document_id",
    updateDocumentRawParams: "UpdateDocumentRawParams",
  });
});

export function updateDocumentRawRequestToJSON(
  updateDocumentRawRequest: UpdateDocumentRawRequest,
): string {
  return JSON.stringify(
    UpdateDocumentRawRequest$outboundSchema.parse(updateDocumentRawRequest),
  );
}
export function updateDocumentRawRequestFromJSON(
  jsonString: string,
): SafeParseResult<UpdateDocumentRawRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateDocumentRawRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateDocumentRawRequest' from JSON`,
  );
}
